import Common from "../../../../Common";
import { TtsPlayBody } from "../../../company/pbx/soundfile/Tts";

const Tts = class extends Common {
	browse = (userId: id, soundId: id) =>
		this.get(`/user/${userId}/profile/soundfile/${soundId}/tts`);

	read = (userId: id, soundId: id, id: id) =>
		this.get(`/user/${userId}/profile/soundfile/${soundId}/tts/${id}`);

	language = (userId: id): CustomResponse<TTSLanguage[]> =>
		this.get(`/user/${userId}/profile/soundfile/tts/language`);

	play = (userId: id, body: TtsPlayBody): CustomResponse<Blob> =>
		this.post(
			`/user/${userId}/profile/soundfile/tts`,
			{
				...body,
				tts_rate: body.tts_rate ?? null,
				tts_pitch: body.tts_pitch ?? null,
			},
			{
				responseType: 'blob'
			}
		)
}

export default Tts
